export default __webpack_public_path__ + "static/color-interaction-states-light-fb7d971a43d1dd288bcd4bd5d9ad66d4.png";